/** Tasks — create form (RHF + zod + shadcn Form via Refine useForm). */
import { useForm } from "@refinedev/react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { TASK_STATUS, createTaskSchema, type CreateTaskInput } from "@aos/shared";

import { Form } from "@/components/ui/form";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

import { PageHeader } from "../projects/_shared";
import {
  FormGrid,
  SelectField,
  TextAreaField,
  TextField,
} from "../projects/_form";

export function TaskCreate() {
  const form = useForm<CreateTaskInput, any, CreateTaskInput>({
    resolver: zodResolver(createTaskSchema),
    defaultValues: {
      artifact_id: "",
      instruction: "",
      result: "",
      assignee_user_id: "",
      task_status: "new",
    },
    refineCoreProps: { resource: "tasks", action: "create" },
  });

  const {
    refineCore: { formLoading },
    saveButtonProps,
    control,
  } = form;

  return (
    <div className="mx-auto max-w-3xl space-y-6">
      <PageHeader
        title="New Task"
        description="Create a task linked to an artifact."
      />
      <Form {...form}>
        <form onSubmit={saveButtonProps.onClick}>
          <Card>
            <CardHeader>
              <CardTitle className="text-base">Task details</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <FormGrid>
                <TextField
                  control={control}
                  name="artifact_id"
                  label="Artifact ID"
                  placeholder="art_…"
                  description="The artifact this task belongs to."
                />
                <SelectField
                  control={control}
                  name="task_status"
                  label="Status"
                  options={TASK_STATUS}
                />
              </FormGrid>
              <TextField
                control={control}
                name="assignee_user_id"
                label="Assignee User ID"
                placeholder="user_…"
              />
              <TextAreaField
                control={control}
                name="instruction"
                label="Instruction"
                placeholder="What should be done?"
              />
              <TextAreaField
                control={control}
                name="result"
                label="Result"
                placeholder="Outcome (filled in later)."
              />
            </CardContent>
            <CardFooter className="justify-end">
              <Button type="submit" disabled={formLoading}>
                {formLoading ? "Creating…" : "Create Task"}
              </Button>
            </CardFooter>
          </Card>
        </form>
      </Form>
    </div>
  );
}

export default TaskCreate;
